import { useQuery } from '@tanstack/react-query';
import { requestStripeUrl } from '../stripeBilling/stripeBilling';
import { CreateStripeSessionRequest } from '../stripeBilling/types/createStripeSessionRequest';

export function useGetStripeUrl(offerKey: CreateStripeSessionRequest) {
    return useQuery({
        queryKey: [`stripeBilling-${offerKey.offerKey}`],
        enabled: !!offerKey.offerKey,
        gcTime: 10000,
        queryFn: async ({ signal }) => (await requestStripeUrl(offerKey, signal)).data,
    });
}
